import { ReactElement } from 'react';

interface PressureStats {
  label: string;
  start: number;
  mean: number;
  end: number;
}

const MBAR_PER_BAR = 1000;

function computeStats(label: string, samples: unknown): PressureStats | null {
  if (!Array.isArray(samples)) return null;
  const finite = samples.filter((value): value is number => typeof value === 'number' && Number.isFinite(value));
  if (!finite.length) return null;
  const mean = finite.reduce((sum, value) => sum + value, 0) / finite.length;
  return {
    label,
    start: finite[0] / MBAR_PER_BAR,
    mean: mean / MBAR_PER_BAR,
    end: finite[finite.length - 1] / MBAR_PER_BAR,
  };
}

function TyrePressureSummary(props: { run: { data_gridded: any } }): ReactElement | null {
  const dataGridded = props.run.data_gridded || {};
  const stats = [
    computeStats('Front Tyre', dataGridded.FrontTpmPressure_pG10),
    computeStats('Rear Tyre', dataGridded.RearTpmPressure_pG10),
  ].filter((entry): entry is PressureStats => entry !== null);

  if (!stats.length) return null;

  return (
    <div className="cr-overflow-hidden cr-rounded-xl cr-bg-clip-border cr-p-5 cr-shadow-md">
      <div className="cr-mb-2 cr-font-semibold">Tyre Pressure</div>
      <div className="cr-flex cr-flex-row cr-gap-10">
        {stats.map((entry) => (
          <div key={entry.label}>
            <div className="cr-text-sm cr-font-medium">{entry.label}</div>
            <div className="cr-text-sm">
              Start {entry.start.toFixed(2)} bar &middot; Mean {entry.mean.toFixed(2)} bar &middot; End{' '}
              {entry.end.toFixed(2)} bar
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default TyrePressureSummary;
